module.exports = __webpack_public_path__ + "github-light.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/github-light.png
// module id = 28
// module chunks = 0